import { create } from 'zustand';
import {
	createReviewPageSlice,
	type ReviewPageSlice,
} from '@/routes/review/-store';

/**
 * Root store interface combining all slices
 * Add new slices here as the app grows
 *
 * This is the main store that combines all feature slices across the application.
 * Each slice should be imported and spread into the store configuration.
 */
export interface RootStore extends ReviewPageSlice {
	// Future global slices can be added here
	// e.g., userSlice: UserSlice;
}

export const useAppStore = create<RootStore>()((set, get, api) => ({
	...createReviewPageSlice(set, get, api),
}));
